const InputField = ({ formik, name, children }) => {
  const isShowError = formik.errors[name] && formik.touched[name]

  return (
    <div
      key={name}
      className={isShowError ? 'input-block input-error' : 'input-block'}
    >
      {children}
      {isShowError && <span className="input-text">{formik.errors[name]}</span>}
    </div>
  )
}

export default InputField
